export default class ObjectHelper {

    static limparDados(data, blankValue, undefinedValue, nullValue) {
        const dadosLimpos = {};

        if (data == null || data == undefined) {
            return dadosLimpos;
        }

        Object.entries(data).forEach(item => {

			if (!blankValue && item[1] === "") {
				return;
			}

			if (!undefinedValue && item[1] === undefined) {
				return;
			}

			else if (!nullValue && item[1] === null) {
				return;
			}

            dadosLimpos[item[0]] = item[1];

        });

        return dadosLimpos;
    }



	static isBool(value) {
		return value === true || value === false || value === "false" || value === "true";
	}
}
